import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "toggle"]
  static values = { show: String, hide: String }

  connect() {
    this.inputTarget.type = "password"
    this.updateButton(false)
    this.toggleTarget.hidden = false
  }

  toggle() {
    const visible = this.inputTarget.type === "password"
    this.inputTarget.type = visible ? "text" : "password"
    this.updateButton(visible)
  }

  updateButton(visible) {
    const label = visible ? this.hideValue : this.showValue
    this.toggleTarget.setAttribute("aria-label", label)
    this.toggleTarget.setAttribute("title", label)
    this.toggleTarget.classList.toggle("is-visible", visible)
  }

  disconnect() {
    this.inputTarget.type = "password"
    this.toggleTarget.hidden = true
  }
}
